var _excluded = ["children", "className", "persist", "theme", "defaultTheme"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import PropTypes from "prop-types";
import React, { forwardRef, useState, useCallback } from "react";
import { useIsomorphicLayoutEffect } from "../../utils/hooks";
import AThemeContext from "./AThemeContext";
var DEFAULT_THEME = "default";
var DUSK_THEME = "dusk";
var SUPPORTED_THEMES = [DEFAULT_THEME, DUSK_THEME];
var DEFAULT_INITIAL_THEME = DEFAULT_THEME;
function isSupportedTheme(theme) {
  return SUPPORTED_THEMES.includes(theme);
}
var ThemeStorage = /*#__PURE__*/function () {
  function ThemeStorage() {
    _classCallCheck(this, ThemeStorage);
  }
  _createClass(ThemeStorage, null, [{
    key: "isSupported",
    value: function isSupported() {
      return typeof localStorage !== "undefined";
    }
  }, {
    key: "loadTheme",
    value: function loadTheme() {
      return localStorage.getItem(ThemeStorage.LS_KEY);
    }
  }, {
    key: "saveTheme",
    value: function saveTheme(theme) {
      localStorage.setItem(ThemeStorage.LS_KEY, theme);
    }
  }]);
  return ThemeStorage;
}();
_defineProperty(ThemeStorage, "LS_KEY", "persist-magna-react-theme");
var ATheme = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    propsClassName = _ref.className,
    persist = _ref.persist,
    theme = _ref.theme,
    defaultTheme = _ref.defaultTheme,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (persist && theme) {
    console.warn('Do not use "theme" and "persist" props at the same time in "ATheme". Providing a "theme" prop indicates that the theme is managed from outside and it will not be persisted.');
  }
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    currentTheme = _useState2[0],
    _setCurrentTheme = _useState2[1]; // undefined indicates not initialized

  var shouldUseThemeStorage = ThemeStorage.isSupported() && persist &&
  // persist is enabled
  !theme; // theme not managed from outside via theme prop

  // eagerly returns the highest priority setting
  var getInitialClientTheme = useCallback(function () {
    // when persistence should be used
    if (shouldUseThemeStorage) {
      var persistedTheme = ThemeStorage.loadTheme();
      if (isSupportedTheme(persistedTheme)) {
        return persistedTheme;
      }
    }
    // supported theme in 'theme'
    if (isSupportedTheme(theme)) {
      return theme;
    }
    // supported theme in 'defaultTheme'
    if (isSupportedTheme(defaultTheme)) {
      return defaultTheme;
    }
    // fallback
    return DEFAULT_INITIAL_THEME;
  }, [shouldUseThemeStorage, theme, defaultTheme]);

  // set initial theme based on client settings
  useIsomorphicLayoutEffect(function () {
    _setCurrentTheme(getInitialClientTheme());
    // run just once
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // reflect theme prop changes to currentTheme
  useIsomorphicLayoutEffect(function () {
    _setCurrentTheme(function (previousTheme) {
      // change the current theme only if it has been initialized already
      // to avoid a race condition with the theme initialization effect
      var themeInitialized = typeof previousTheme !== "undefined";
      return themeInitialized && isSupportedTheme(theme) ? theme : previousTheme;
    });
  }, [theme]);

  // persist currentTheme on change
  useIsomorphicLayoutEffect(function () {
    if (shouldUseThemeStorage) {
      ThemeStorage.saveTheme(currentTheme);
    }
  }, [currentTheme]);
  var isDark = currentTheme === DUSK_THEME;
  var isLight = currentTheme !== DUSK_THEME;
  var themeContext = {
    persist: persist,
    currentTheme: currentTheme,
    isDark: isDark,
    isLight: isLight,
    setCurrentTheme: function setCurrentTheme(theme) {
      if (isSupportedTheme(theme)) {
        _setCurrentTheme(theme);
      }
    }
  };
  var className = currentTheme === DUSK_THEME ? "theme--dusk" : "theme--default";
  if (propsClassName) {
    className += " ".concat(propsClassName);
  }
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    ref: ref,
    className: className
  }), /*#__PURE__*/React.createElement(AThemeContext.Provider, {
    value: themeContext
  }, children));
});
ATheme.propTypes = {
  /**
   * Toggles whether the theme is loaded from local storage on mount, and persisted to local storage on theme change.
   */
  persist: PropTypes.bool,
  /**
   * Sets the default theme on mount. Changes to this prop are not reflected as a current theme.
   */
  defaultTheme: PropTypes.oneOf(SUPPORTED_THEMES),
  /**
   * Sets the current theme. Changes to this prop are reflected as a current theme. Takes precedence over defaultTheme. Do not use "theme" and "persist" props at the same time. Providing a "theme" prop indicates that the theme is managed from outside and it will not be persisted.
   */
  theme: PropTypes.oneOf(SUPPORTED_THEMES)
};
ATheme.displayName = "ATheme";
export default ATheme;